export const pricingPage = {
  path: '/pricing',
  images: {
    hero: '/feature-payments.webp',
  },
  seoTitle: 'Restaurant POS System Pricing | Tillio POS',
  seoDescription:
    'Cloud POS system pricing for restaurants: $99/mo platform fee and a 1.1% Tillio flat rate plus Stripe processing fees. No setup fees. Unlimited devices.',
  hero: {
    title: 'Straightforward pricing for your POS system.',
    description:
      "One platform fee for your cloud-based point of sale. A flat 1.1% Tillio rate on cards—plus Stripe's own processing rates. No surprise per-device charges.",
  },
}
